var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-link",class:_vm.classes,on:{"click":_vm.actionClick}},[_c('img',{attrs:{"src":require("../../assets/images/grid-icon.svg"),"alt":"Grid Icon"}}),_c('span',{domProps:{"textContent":_vm._s(_vm.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }